module.exports = {
      id: "sharechat-usage",
      viewBox: "0 0 29.14 29.14",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#sharechat",
      toString: function () {
        return this.url;
      }
    }